<template>
  <v-card
    width="100%"
    height="auto"
    class="mt-0"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('task') }} </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            v-on="on"
            @click="goTo('task')"
          >
            <v-icon
              color="teal"
              style="font-size: 26px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('task') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            v-on="on"
            @click="goTo( 'TaskList')"
          >
            <v-icon
              color="primary"
              style="font-size: 26px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('taskList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 26px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row class="ma-0">
        <v-col
          cols="12"
          md="3"
          class=""
        >
          <aicomplete
            v-model="template"
            :title="$t('spaceWork')"
            type="statusTemplate"
            :outlined="true"
            :new-btn="true"
            :set-init="true"
            :height="'30'"
            :val="template"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <status
            ref="refStatus"
            v-model="status"
            type="task"
            :config="true"
            :hideconfig="true"
            :template-prop="template"
            :value="status"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="d-flex"
        >
          <v-chip
            v-if="! dueDate"
            label
            @click="timeDialog = true"
          >
            {{ $t('set-due-date') }}
          </v-chip>
          <v-chip
            v-for="(day, index) in days"
            v-show="! dueDate && index < 4"
            :key="index"
            outlined
            label
            class="mx-1"
            :color="day.color"
            @click="setDate(day.day)"
          >
            <strong>{{ $t(day.text) }}</strong>  &nbsp;
            <span> ( {{ day.date }} ) </span>
          </v-chip>
          <v-chip
            v-if="startDate"
            outlined
            label
            class="mx-1"
            close
            @click="timeDialog = true"
            @click:close="startDate = null"
          >
            {{ $t('start-date') }} : {{ startDate }}
          </v-chip>
          <v-chip
            v-if="dueDate"
            label
            class="mx-1"
            color="primary"
            outlined
            close
            @click:close="dueDate = null"
            @click="timeDialog = true"
          >
            {{ $t('due-date') }} : {{ dueDate }}
          </v-chip>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col
          cols="12"
          md="6"
          class="pa-0"
        >
          <v-col
            cols="12"
            md="12"
            class="mb-0"
          >
            <v-text-field
              v-model="title"
              :label="$t('title')"
              :rules="[
                v => !!v || $t('is-required'),
                v => (v && v.length < 250) || $t('title-must-be-less-than-250-characters'),
              ]"
              outlined
              clearable
              hide-details
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="mb-0"
          >
            <tag
              v-model="tag"
              :solo="false"
              :input="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="my-0 py-0"
          >
            <tiptap-vuetify
              v-model="content"
              :extensions="extensions"
              :toolbar-attributes="{ color: '#ababab', dark: true }"
              class="mt-3"
            />
          </v-col>
          <v-col
            cols="12"
            style="height: auto !important;"
          >
            <autocomplete
              v-model="functor"
              title="functor"
              type="partners"
              :filter="false"
              :multiple="false"
              :value="functor"
            />
          </v-col>
          <v-col
            cols="12"
            style="height: auto !important;"
          >
            <autocomplete
              v-model="participants"
              title="participants"
              type="partners"
              :filter="true"
              :multiple="true"
              :value="participants"
            />
          </v-col>
          <v-row class="mx-0 mb-1 mt-1">
            <v-col
              cols="12"
              md="3"
              class="mb-0"
            >
              <v-select
                v-model="typeMethod"
                :label="$t('relation-whit')"
                :items="typeItems"
                height="30"
                dense
                outlined
                item-value="value"
                item-text="text"
              />
            </v-col>
            <v-col
              class="mb-0"
              cols="12"
              md="9"
            >
              <autocomplete
                ref="refRelation"
                v-model="relation"
                :title="(typeMethod == 'account' ? 'customer' : 'invoice')"
                :type="(typeMethod == 'account' ? 'person' : 'invoices')"
                :value="relation"
              />
            </v-col>
            <v-col
              v-if="typeMethod == 'account'"
              class="mb-0 pb-0"
              cols="12"
              md="9"
            >
              <v-chip
                v-if="relation && relation.mobile"
                outlined
              >
                {{ $t('mobile') }} : {{ relation.mobile }}
              </v-chip>
              <v-chip
                v-if="relation && relation.phone"
                outlined
              >
                {{ $t('phone') }} : {{ relation.phone }}
              </v-chip>
            </v-col>
          </v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="link"
              :label="$t('link')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            style="min-height:50px;height: auto !important;"
          >
            <file-picker
              ref="refFilePicker"
              v-model="imagePicker"
              :label="$t('uploadFile')"
              :multiple="true"
              type-prop="taskAttachment"
              :val="(imagePickerVal ? imagePickerVal : null)"
            />
          </v-col>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-img
            v-if="!id && !isMobile"
            class="mx-auto"
            width="400"
            style="-webkit-transform: scaleX(-1);transform: scaleX(-1);border-radius: 10px"
            src="@/assets/task.jpg"
          />
          <comments
            v-show="id"
            :ref_id="id"
          />
        </v-col>
      </v-row>
      <v-row class="mx-0 px-4">
        <notification
          v-model="notifications"
          :value="notifications"
        />
      </v-row>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="insert"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('update') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-1"
          />
        </v-row>
      </v-card-actions>
    </v-form>
    <v-dialog
      v-model="timeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            @click="timeDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            style="height: auto"
            cols="12"
          >
            <v-chip
              v-for="(day, index) in days"
              :key="index"
              outlined
              label
              small
              class="mx-1"
              :color="day.color"
              style="margin-top: 10px"
              @click="setDate(day.day)"
            >
              {{ $t(day.text) }}  - {{ day.date }}
            </v-chip>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <template>
              <v-text-field
                id="startDate"
                v-model="startDate"
                :label="$t('start-date')"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="startDate"
                element="startDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                clearable
                :max="(dueDate ? dueDate : null)"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <template>
              <v-text-field
                id="fromTime"
                v-model="startTime"
                :label="$t('start-time')"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="startTime"
                element="fromTime"
                :locale="$store.state.date_locale"
                type="time"
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              />
            </template>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="6"
          >
            <template>
              <v-text-field
                id="toDate"
                v-model="dueDate"
                :label="$t('due-date')"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="dueDate"
                element="toDate"
                :min="(startDate ? startDate : null)"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <template>
              <v-text-field
                id="toTime"
                v-model="dueTime"
                :label="$t('due-time')"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="dueTime"
                element="toTime"
                type="time"
                :locale="$store.state.date_locale"
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              />
            </template>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col
              class="flex-column-reverse"
              cols="6"
            >
              <v-btn
                color="grey"
                outlined
                class="mx-0"
                @click="timeDialog = false"
              >
                {{ $t('close') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
    />
  </v-card>
</template>

<script>
  import Status from '../../components/general/Status/status'
  import Comments from './comment'
  import aicomplete from '../../components/general/AIcomplete/index'
  import autocomplete from '../../components/general/patial/autocomplete'
  import General from '../../../../Mixins/general'
  import filePicker from '../../components/general/filePicker/index'
  import {
    // component
    TiptapVuetify,
    // extensions
    Heading,
    Bold,
    Italic,
    Strike,
    Underline,
    Code,
    Paragraph,
    BulletList,
    OrderedList,
    ListItem,
    Link,
    Blockquote,
    HardBreak,
    HorizontalRule,
    History,
    Image,
    Table,
    TableCell,
    TableHeader,
    TableRow,
  } from 'tiptap-vuetify'
  export default {
    name: 'Customer',
    components: {
      TiptapVuetify,
      filePicker,
      aicomplete,
      autocomplete,
      Comments,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status,
    },
    mixins: [General],
    props: ['refId', 'taskType', 'taskId', 'refItem', 'refType', 'copy'],
    data: () => ({
      extensions: [
        History,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem, // if you need to use a list (BulletList, OrderedList)
        BulletList,
        OrderedList,
        Image,
        [
          Heading,
          {
            // Options that fall into the tiptap's extension
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak, // line break on Shift + Ctrl + Enter
      ],
      content: '',
      snakbar: false,
      notifications: null,
      functor: null,
      taskAttachment: null,
      imagePicker: null,
      imagePickerVal: null,
      template: null,
      relation: null,
      typeMethod: 'account',
      snakbarText: null,
      participants: null,
      snakbarColor: null,
      isLoading: false,
      timeDialog: false,
      gender: 'man',
      startDate: null,
      startTime: null,
      dueDate: null,
      dueDateWatch: null,
      dueTime: null,
      typeItems: null,
      tag: null,
      link: null,
      description: null,
      id: null,
      status: null,
      new: false,
      valid: null,
      title: null,
      ref_id: null,
      type: null,
      days: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
    },
    watch: {
      template () {
        localStorage.setItem('taskTemplate', JSON.stringify(this.template))
      },
      typeMethod () {
        if (!this.loading) {
          this.relation = null
          this.$refs.refRelation.clear()
          if (this.typeMethod) {
            this.$refs.refRelation.initList = false
            this.$refs.refRelation.getItems({ query: null, page: 1 })
          }
        }
      },
      refItem () {
        this.typeMethod = this.refType
        this.relation = this.refItem
      },
      timeDialog () {
        if (this.timeDialog === false) {
          // this.create()
        }
      },
      taskId (val, oldVal) {
        this.clearForm()
        if (val) {
          this.getItem()
        }
      },
      // tag () {
      //   this.create()
      // },
      // status () {
      //   this.create()
      // },
      // description () {
      //   this.create()
      // },
    },
    beforeMount () {
      this.typeItems = [
        {
          value: 'invoice',
          text: this.$t('invoice'),
        },
        {
          value: 'account',
          text: this.$t('customer'),
        },
      ]
      var template = localStorage.getItem('taskTemplate')
      if (template && template !== undefined) {
        this.template = JSON.parse(template)
      }
    },
    mounted () {
      var m1 = this.$moment()
      var m2 = this.$moment()
      var m3 = this.$moment()
      var m4 = this.$moment()
      var m5 = this.$moment()
      var format = 'D MMM'
      var locale = 'en'
      if (this.$store.state.date_locale === 'fa,en') {
        format = 'jD jMMM'
        locale = 'fa'
      }
      this.days = [
        {
          day: 0,
          date: m1.add(0, 'day').locale(locale).format(format),
          color: 'pink',
          text: 'today',
        },
        {
          day: 1,
          date: m2.add(1, 'day').locale(locale).format(format),
          color: 'orange',
          text: 'tomorrow',
        },
        {
          day: 7,
          date: m3.add(7, 'day').locale(locale).format(format),
          color: 'blue-grey',
          text: 'next-week',
        },
        {
          day: 14,
          date: m4.add(14, 'day').locale(locale).format(format),
          color: 'cyan',
          text: 'two-week',
        },
        {
          day: 28,
          date: m5.add(28, 'day').locale(locale).format(format),
          color: 'green',
          text: 'four-week',
        },
      ]
      this.currency = JSON.parse(localStorage.getItem('token')).init.currency
      if (this.taskId) {
        this.typeMethod = null
        this.getItem()
      }
      if (this.$route.params.id != null) {
        // this.taskId = this.$route.params.id
        this.id = this.$route.params.id
        this.typeMethod = null
        this.getItem()
      }
      if (this.refItem) {
        this.typeMethod = this.refType
        this.relation = this.refItem
      }
    },
    methods: {
      back () {
        this.$emit('close')
        // this.goTo('taskDesk')
      },
      setDate (day) {
        var m = this.$moment()
        m.add(day, 'day')
        var date = null
        if (this.$store.state.date_locale === 'fa,en') {
          date = m.format('jYYYY/jMM/jDD')
        }
        if (this.$store.state.date_locale === 'en,fa') {
          date = m.format('YYYY/MM/DD')
        }
        this.dueDate = date
        this.startDate = null
        // this.create()
      },
      insert () {
        this.new = true
        this.create()
      },
      create () {
        if (!this.title) {
          return false
        }
        if (!this.id && !this.new) return false
        var app = this
        app.type = app.taskType
        app.ref_id = app.refId
        app.isLoading = true
        app.description = app.content
        app.$axios.post(this.$endpoint + 'task', this.$data)
          .then(res => {
            app.id = res.data.data.id
            if (app.imagePicker && app.imagePicker.length > 0) {
              app.$refs.refFilePicker.create(app.id)
            }
            if (app.new) {
              this.snakbarText = app.$t('alert-created')
            } else {
              this.snakbarText = app.$t('alert-edited')
            }
            this.snakbar = true
            app.clearForm()
            app.back()
            app.$refs.form.resetValidation()
            if (app.copy === true) {
              app.$router.go(-1)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.new = false
            app.isLoading = false
          })
      },
      update () {
        if (!this.title) {
          return false
        }
        if (!this.id && !this.new) return false
        var app = this
        app.type = app.taskType
        app.ref_id = app.refId
        app.isLoading = true
        app.description = app.content
        app.$axios.post(this.$endpoint + 'task', this.$data)
          .then(res => {
            app.id = res.data.data.id
            if (app.imagePicker && app.imagePicker.length > 0) {
              app.$refs.refFilePicker.create(app.id)
            }
            if (app.new) {
              this.snakbarText = app.$t('alert-created')
            } else {
              this.snakbarText = app.$t('alert-edited')
            }
            this.snakbar = true
            app.$router.go(-1)
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.new = false
            app.isLoading = false
          })
      },
      getItem () {
        // this.clearForm()
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'task/' + app.$route.params.id + '/edit', {
          params: {
            id: app.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            if (app.copy) {
              app.id = null
            } else {
              app.id = res.id
            }
            app.title = res.title
            app.typeMethod = res.type
            app.imagePicker = res.task_attachment
            app.imagePickerVal = res.task_attachment
            app.notifications = res.notifications
            app.functor = res.functor
            app.relation = res.relation
            app.content = res.content
            app.startDate = res.due_date
            app.participants = res.party
            app.link = res.link
            app.startTime = res.due_time
            app.template = res.last_status.status.template
            app.status = res.last_status.status
            app.dueDate = res.due_end_date
            app.dueTime = res.due_end_time
            if (res.tags.length > 0) {
              app.tag = res.tags
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearForm () {
        this.content = ''
        this.snakbar = false
        this.snakbarText = null
        this.snakbarColor = null
        this.isLoading = false
        this.timeDialog = false
        this.typeMethod = 'account'
        this.relation = null
        this.taskAttachment = null
        this.startDate = null
        this.startTime = null
        this.dueDate = null
        this.dueDateWatch = null
        this.dueTime = null
        this.tag = null
        this.link = null
        this.description = null
        this.id = null
        this.new = false
        this.participants = null
        this.title = null
        this.ref_id = null
        this.type = null
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
.tiptap-vuetify-editor__btn-icon {
  color: #4c4c4c !important;
}
</style>
